/**
 * this module is used to overwrite all project dependent client config options handled by frontend-controller/lib/appConfig.js
 */
module.exports = {
	useFecClient: true,
	store: {
		name: 'TarantulaStore'
	},
	// @see MARK: FEC_LANGUAGE_CONFIG
	language: {
		available: {
			'de-at': {
				icon: 'flag-icon flag-icon-at',
			},
			// 'en-gb': {
			// 	icon: 'flag-icon flag-icon-gb',
			// },
		},
	},
	error: {
		handleClientError: false
	},
	cache: {
		reuseCachedHtml: false,
		grantCacheByETag: true,		// should the fec client be allowed to cache requests based on etag?
	},
	render: {
		suppressEmptyTemplates: (process.env.NODE_ENV || 'production') === 'production'		// should the empty default template and the corresponding warnings be suppressed?
	},
	debug: {
		componentListDebugging: false,
		injectComponentInstanceID: false,
	},
	timeMeasurement: false,
	statusControllerActionHandling: true,
	validator: {
		defaultLocale: 'de-DE'
	},
	newsletter: {
		routePathSalt: 'QgXV5UCcNlTjUjitFH5IcZS9uHFoltcHup7FiOe9TQatsC0PMGamIOI4xVA33YjVpKGtlWqsvxNBhMfMq4KHklDDhwA5nOLt02JxUYeV4meYhGBEPD2qsfvLToDexntO'
	},
	useIDSelector: true,
};
